export const getFileSizeInMb = function (size: number) {
    const mbConversionValue = 1024 * 1024;
    const megabyteSize = size / mbConversionValue;
    const roundedMegabyteSize = parseFloat(megabyteSize.toFixed(2));
    return roundedMegabyteSize;
};
